/**
 * Generic enum dropdown for the product filter row. Wraps the standard
 * label + MUI Select pattern. Reused for Product Status, Product Type,
 * Inventory Tracking, Stock, Last Sold (Aging).
 */
import React from 'react'
import { FormControl, Select, MenuItem, Typography, Box, SelectChangeEvent } from '@mui/material'

interface Option {
  value: string
  label: string
}

interface EnumDropdownFieldProps {
  label: string
  value: string
  options: Option[]
  onChange: (value: string) => void
  disabled?: boolean
}

const labelStyle = {
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '0.75rem',
  mb: 0.5,
  display: 'block',
}

const EnumDropdownField: React.FC<EnumDropdownFieldProps> = ({
  label, value, options, onChange, disabled,
}) => {
  const handleChange = (e: SelectChangeEvent) => onChange(e.target.value)
  return (
    <Box>
      <Typography component="label" sx={labelStyle}>{label}</Typography>
      <FormControl fullWidth size="small">
        <Select displayEmpty value={value} onChange={handleChange} disabled={disabled}>
          {options.map((o) => (
            <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default EnumDropdownField
